import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import Select, { components } from 'react-select'
import { Success, Warning } from './helperComponents'
import { getRequest, postRequest } from '../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../context/global_context'
import { downloadErrorLogs } from '../../utils/common'

const MissingLogOption = {
  value: 'log_missing_components',
  label: 'Log missing components',
}

const { Option } = components
const StatusOption = (props) => (
  <Option {...props}>
    <div className="flex flex-row space-x-4">
      <div>{props.data.label}</div>
      <div className="pt-1">{props.data.statusSvg}</div>
    </div>
  </Option>
)

const DropdownActions = ({ fileType, uploadState, reloadData }) => {
  const [value, dispatch] = useContext(NavContext)

  let { vehicle } = useParams()

  const selected = uploadState?.selected_version?.value
  const disabledDownloadLogs =
    uploadState?.selected_version?.value?.has_error &&
    fileType == uploadState?.file_type
      ? true
      : false
  const disabledDownload =
    ([
      'all',
      'current_state_inlcude_not_constrained',
      'current_state_include_part_number',
    ].includes(uploadState?.selected_version?.value) ||
      uploadState?.selected_version?.id) &&
    fileType === uploadState?.file_type &&
    !uploadState?.selected_version?.value?.error_reason

  const disabledRollback =
    (['all'].includes(uploadState?.selected_version?.value) ||
      uploadState?.selected_version?.id) &&
    fileType === uploadState?.file_type &&
    !uploadState?.selected_version?.value?.error_reason

  const [selectedAction, setSelectedAction] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const importFileId =
    selected && (selected === 'all' ? '' : uploadState?.selected_version?.id)

  const downloadPath = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Downloading requested data',
        showLoader: true,
      },
      notification: {},
    })

    let formData = new FormData()
    formData.append('vehicle_id', vehicle)
    if (uploadState?.selected_version?.id) {
      formData.append('importer_id', uploadState?.selected_version?.id)
    }
    formData.append('file_type', uploadState?.file_type)
    if (!uploadState?.selected_version?.value?.id) {
      formData.append('selected_version', uploadState?.selected_version?.value)
    }

    let res = await postRequest('/api/importer/export/', formData, true)
    if (res?.msg) {
      dispatch({
        type: 'notification',
        data: { notification_type: 'error', msg: res?.msg },
      })
    } else {
      const url = window.URL.createObjectURL(new Blob([res]))
      const link = document.createElement('a')
      link.href = url
      if (uploadState?.file_type === 'connector_layout') {
        link.setAttribute(
          'download',
          `${value.make_model_id}_${vehicle}_${uploadState?.file_type}${uploadState?.selected_version?.value === 'current_state_include_part_number' ? '_PN' : ''}.zip`
        )
      } else {
        link.setAttribute(
          'download',
          `${value.make_model_id}_${vehicle}_${uploadState?.file_name}`
        )
      }
      document.body.appendChild(link)
      link.click()
      link.remove()

      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File downloaded successfully',
          loader: true,
        },
      })
    }
  }

  const downloadLogs = async () => {
    let res = await getRequest(
      `/api/importer/download_logs/?download_id=${selected.id}`
    )
    let data = res?.data
    if (data?.error?.length > 0) {
      let text = data?.error
      downloadErrorLogs(text)
    } else {
      if (data) {
        let text = [data]
        downloadErrorLogs(text)
      } else {
        alert('Logs not available.')
      }
    }
  }

  const status =
    selected && selected !== 'all' ? (
      selected.status === 'failed' ? (
        <Warning />
      ) : (
        <Success />
      )
    ) : (
      ''
    )

  const tempActionsMenu = [
    { value: 'rollback', label: 'Rollback', isDisabled: !disabledRollback },
    {
      value: 'logs',
      label: 'Logs',
      statusSvg: status,
      isDisabled: !disabledDownloadLogs,
    },
  ]

  const actionsMenu =
    uploadState?.file_type === 'sales_codes' &&
    uploadState?.selected_version?.value !== 'all'
      ? tempActionsMenu
      : [
          ...tempActionsMenu,
          ...[
            {
              value: 'download',
              label: importFileId ? 'Download Diff' : 'Download',
              isDisabled: !disabledDownload,
            },
          ],
        ]

  const handleChange = (event) => {
    if (event.value === 'download') {
      downloadPath()
    } else if (event.value === 'logs') {
      downloadLogs()
    } else if (event.value === 'rollback') {
      setOpenModal(true)
    } else if (event.value === 'log_missing_components') {
      downloadMissingComponent()
    }
    setSelectedAction('')
  }

  const downloadMissingComponent = async () => {
    let res = await postRequest(`/api/dtcs/missing_component/`, {
      vehicle: vehicle,
      version: importFileId,
    })
    if (res.data.dtcs_review?.length > 0) {
      downloadErrorLogs(res.data.dtcs_review, 'dtc_needs_to_review.txt')
    }
    if (res.data.missing_connector_device?.length > 0) {
      downloadErrorLogs(
        res.data.missing_connector_device,
        'missing_components.txt'
      )
    }
    if (
      res.data.dtcs_review?.length < 1 &&
      res.data.missing_connector_device?.length < 1
    ) {
      alert('Logs not available.')
    }
  }

  const confirmRollback = async (e) => {
    e.preventDefault()
    setOpenModal(false)
    dispatch({
      type: 'loader',
      data: {
        caption: `Deleting #${uploadState.selected_version.label} Version`,
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/importer/rollback/?vehicle_id=${vehicle}&file_type=${fileType}&version=${uploadState?.selected_version?.value?.version}`
    )
    if (res?.error_code) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
          loader: false,
        },
      })
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Deleted #${uploadState.selected_version.label} version Successfully`,
          loader: false,
        },
      })
      reloadData()
    }
  }

  return (
    <>
      {openModal && (
        <div className="absolute z-10 min-w-full border border-2 rounded border-gray-300 bg-white mt-3">
          <p className="p-3">
            Are you sure you want to rollback import version from #
            {uploadState.selected_version.label}?
          </p>
          <button
            className="btn py-1 px-2 m-2"
            onClick={(e) => confirmRollback(e)}
          >
            Yes, rollback it
          </button>
          <button
            className="btn py-1 px-2 m-2"
            onClick={() => setOpenModal(false)}
          >
            Cancel
          </button>
        </div>
      )}
      <div className="ml-2 mr-2" style={{ minWidth: '125px' }}>
        <Select
          inputName={'blank'}
          isMulti={false}
          value={selectedAction}
          options={
            uploadState?.file_type !== 'dtcs' || importFileId == ''
              ? actionsMenu
              : [...actionsMenu, MissingLogOption]
          }
          placeholder="Actions"
          className="w-full"
          components={{ Option: StatusOption }}
          onChange={handleChange}
        />
      </div>
    </>
  )
}

DropdownActions.propTypes = {
  fileType: PropTypes.string.isRequired,
  latestVersion: PropTypes.object,
}
export default DropdownActions
